import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IReportEmbedConfiguration } from 'powerbi-client';
import * as fromPowerBI from '../../reducers/power-bi/power-bi.reducer';

export const selectPowerBIState = createFeatureSelector<fromPowerBI.State>(
  fromPowerBI.powerBIFeatureKey
);

export const selectReports = createSelector(
  selectPowerBIState,
  (state: fromPowerBI.State) => state.reports
);

export const selectPowerBIIsLoading = createSelector(
  selectPowerBIState,
  (state: fromPowerBI.State) => state.isLoading
);

export const selectPowerBIIsLoaded = createSelector(
  selectPowerBIState,
  (state: fromPowerBI.State) => state.isLoaded
);
